import { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Grid, Box } from '@mui/material';
import GroupIcon from '@mui/icons-material/Group';
import InventoryIcon from '@mui/icons-material/Inventory';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

const StatCard = ({ icon, label, value, color }) => (
    <Card sx={{ height: '100%' }}>
        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 3 }}>
            <Box sx={{
                width: 48, height: 48, borderRadius: 1,
                bgcolor: `${color}15`, color: color,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
                {icon}
            </Box>
            <Box>
                <Typography variant="body2" color="text.secondary">{label}</Typography>
                <Typography variant="h4" fontWeight={700}>{value}</Typography>
            </Box>
        </CardContent>
    </Card>
);

const Dashboard = () => {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}`, Accept: 'application/json' };

        Promise.all([
            fetch('/api/admin/products?count=10000', { headers }).then(r => r.json()),
            fetch('/api/admin/orders', { headers }).then(r => r.json()),
            fetch('/api/admin/discounts', { headers }).then(r => r.json()),
            fetch('/api/admin/users', { headers }).then(r => r.json()),
        ]).then(([products, orders, discounts, users]) => {
            setStats({
                products: products.length || 0,
                orders: orders.length || 0,
                discounts: discounts.length || 0,
                users: users.length || 0,
                lowStock: products.filter(p => p.count > 0 && p.count < 3).length || 0,
                newOrders: orders.filter(o => o.status === null || o.status === 'Новый').length || 0,
            });
        }).catch(() => {});
    }, []);

    if (!stats) return null;

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 3 }}>Дашборд</Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <StatCard icon={<InventoryIcon />} label="Товаров" value={stats.products} color="#1A1A1A" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <StatCard icon={<ShoppingCartIcon />} label="Заказов" value={stats.orders} color="#C4A35A" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <StatCard icon={<LocalOfferIcon />} label="Скидок" value={stats.discounts} color="#2E7D32" />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <StatCard icon={<GroupIcon />} label="Пользователей" value={stats.users} color="#1565C0" />
                </Grid>
            </Grid>
            {(stats.lowStock > 0 || stats.newOrders > 0) && (
                <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                    {stats.lowStock > 0 && (
                        <Card sx={{ flex: 1, bgcolor: '#FFF3E0' }}>
                            <CardContent>
                                <Typography fontWeight={600} color="#E65100">
                                    ⚠ {stats.lowStock} товаров с остатком менее 3 шт
                                </Typography>
                            </CardContent>
                        </Card>
                    )}
                    {stats.newOrders > 0 && (
                        <Card sx={{ flex: 1, bgcolor: '#E3F2FD' }}>
                            <CardContent>
                                <Typography fontWeight={600} color="#1565C0">
                                    📦 {stats.newOrders} новых заказов
                                </Typography>
                            </CardContent>
                        </Card>
                    )}
                </Box>
            )}
        </Box>
    );
};

export default Dashboard;
